import BranchFundingSourceHolidayBaseController from '../common/branch_funding_source_holiday.base.controller'

class BranchFundingSourceHolidayAllController extends BranchFundingSourceHolidayBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, BranchFundingSourceHolidayService, $translate, $stateParams, $location) {

        super(Auth, $state, User, BranchFundingSourceHolidayService, Modal, $translate, $stateParams, $location)

        this.id = 'branch-funding-source-holiday.all'
        this._status = 'all'
        this.page = 1;
        this.total = 0;
        this.pageLimit = 10;
        this.maxPages = 10;
        this.loading = true;
        this.branchFundingSourceHolidayData = [];
        this.hasAcl = {};
        this.searchText = '';
        this.$location = $location;
        this.branch = User.getUser().branchId;
    }

    $onInit() {
        let pageId = this.$stateParams.page
        if (pageId > 0) {
            this.page = pageId;
        }
        this.loadData();
    }

    edit(branchFundingSourceHoliday) {
        this.$state.go('branch-funding-source-holiday.edit', ({
            id: branchFundingSourceHoliday.id
        }))
    }

    delete(branchFundingSourceHoliday) {
        if (this.allowOnlyOnce) return;
        this.allowOnlyOnce = true;
        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_delete_title'),
            message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${branchFundingSourceHoliday.id}</strong>?`,
            callback: (({
                modal,
                $scope
            }) => {
                $scope.loading = true;
                this.Service.remove(branchFundingSourceHoliday.id, branchFundingSourceHoliday.branchFundingSourceId, this.branch)
                    .then((data) => {
                        this.allowOnlyOnce = false;
                        modal.close();
                        this.refresh();
                    })
            }),
            negative: (({
                modal,
            }) => {
                this.allowOnlyOnce = false;
                modal.close();
            }),
            type: 'danger'
        })
    }

    refresh() {
        this.loadData();
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
        this.$stateParams.page = this.page;
        this.$location.path(newUrl)
        this.loadData()
    }

    generateSearchObj() {
        const obj = {
            queryJSON: {
                rules: [{
                    field: 'id',
                    condition: 'like',
                    data: '%' + this.searchText + '%'
                },
                {
                    field: 'name',
                    condition: 'like',
                    data: '%' + this.searchText + '%'
                }],
                operator: 'OR'
            }
        }
        return obj.queryJSON.rules.length ? obj : null;
    }

    search() {
        this.page = 1;
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
        this.$stateParams.page = this.page;
        this.$location.path(newUrl)
        this.loadData()
    }

    loadData() {
        const searchObj = this.generateSearchObj();

        this.loading = true;
        this.Service.all(searchObj, this.branch, (this.page - 1) * this.pageLimit, this.pageLimit)
            .then((data) => {
                this.total = data.total;
                this.branchFundingSourceHolidayData = data.results;
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
                this.error = err.message;
            })
    }

}

export default BranchFundingSourceHolidayAllController;



// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source_holiday/all/branch_funding_source_holiday.all.controller.js